import React, { useState, useEffect } from 'react';
import API_BASE from '../config';
import usePageMeta from '../hooks/usePageMeta';

const STATIC_PROJECTS = [
    { id: 1, name: 'Bluewood 3BHK', location: 'Gachibowli, Hyderabad', city: 'Hyderabad', project_type: 'Residential Flat', description: 'A stunning 3BHK interior featuring a modular kitchen with acrylic shutters, custom wardrobes in all bedrooms, false ceiling with cove lighting, and a luxurious master suite with a walk-in closet.', image_url: '/images/False Ceiling Design.jpg', completion_year: 2024 },
    { id: 2, name: 'Velora 3BHK at Candeur 40', location: 'Kondapur, Hyderabad', city: 'Hyderabad', project_type: 'Residential Flat', description: 'Premium 3BHK interior with a Japandi-inspired design language. Features natural wood finishes, earthy palette, U-shaped modular kitchen, and custom study unit for WFH setup.', image_url: 'https://images.unsplash.com/photo-1618219944342-824e40a13285?w=800&q=80', completion_year: 2024 },
    { id: 3, name: 'Ocean View Duplex', location: 'Whitefield, Bangalore', city: 'Bangalore', project_type: 'Duplex Flat', description: 'A breathtaking duplex interior with a double-height living room, glass-railing staircase, chef\'s modular kitchen, 4 designer bedrooms, and a rooftop lounge.', image_url: 'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800&q=80', completion_year: 2024 },
    { id: 4, name: 'Prestige High Fields – 2BHK', location: 'Kukatpally', city: 'Hyderabad', project_type: 'Residential Flat', description: 'Budget-smart 2BHK interior delivering a premium look with smart space planning. L-shaped kitchen, 2 wardrobes, and a beautiful false ceiling with LED ambiance.', image_url: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80', completion_year: 2023 },
    { id: 5, name: 'Luxury Villa Transformation', location: 'Beach Road', city: 'Vizag', project_type: 'Independent House', description: 'A complete independent villa transformation spanning 3 floors — from grand foyer to terrace — with traditional meets contemporary design philosophy.', image_url: '/images/Pooja & Foyer Design.jpg', completion_year: 2023 },
    { id: 6, name: 'Smart 3BHK – Koramangala', location: 'Koramangala, Bangalore', city: 'Bangalore', project_type: 'Residential Flat', description: 'A tech-forward 3BHK for a software professional family. Features smart storage solutions, island kitchen, home theatre room, and integrated home automation design.', image_url: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=800&q=80', completion_year: 2023 },
    { id: 7, name: 'Vizag Beach Dunes Apartment', location: 'Siripuram, Vizag', city: 'Vizag', project_type: 'Residential Flat', description: 'Coastal-inspired 3BHK interior design with a breezy, open-plan layout, light wood finishes, and views of the Bay of Bengal incorporated into the design narrative.', image_url: 'https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=800&q=80', completion_year: 2023 },
    { id: 8, name: 'Vijayawada Office Interior', location: 'MG Road, Vijayawada', city: 'Vijayawada', project_type: 'Commercial', description: 'A contemporary corporate office interior for a leading FMCG company. Features open-plan workstations, elegant conference rooms, and a vibrant breakout zone.', image_url: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80', completion_year: 2022 },
    { id: 9, name: 'Jubilee Hills Bungalow', location: 'Jubilee Hills, Hyderabad', city: 'Hyderabad', project_type: 'Bungalow', description: 'Ultra-luxury bungalow interior on 3 floors, featuring Italian marble, custom solid wood furniture, a gourmet kitchen, home gym, and a private cinema room.', image_url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80', completion_year: 2022 },
];



function ProjectCard({ project, onClick }) {
    const fallbackImage = 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&q=80';
    return (
        <div className="group cursor-pointer card-hover" onClick={() => onClick(project)}>
            <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100">
                <div className="relative h-60 overflow-hidden">
                    <img
                        src={project.image_url || fallbackImage}
                        alt={project.name}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                        <span className="text-white text-sm font-semibold">View Details →</span>
                    </div>
                    <div className="absolute top-3 right-3 bg-[#2E63E8] text-white text-xs font-bold px-3 py-1 rounded-full">
                        {project.completion_year}
                    </div>
                    <div className="absolute top-3 left-3 bg-black/60 text-white text-xs px-3 py-1 rounded-full backdrop-blur-sm">
                        {project.project_type}
                    </div>
                </div>
                <div className="p-5">
                    <h3 className="text-gray-900 font-bold text-base mb-1">{project.name}</h3>
                    <div className="flex items-center gap-1.5 text-gray-500 text-xs mb-2">
                        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        </svg>
                        {project.location}
                    </div>
                    <p className="text-gray-500 text-sm line-clamp-2">{project.description}</p>
                </div>
            </div>
        </div>
    );
}

function ProjectModal({ project, onClose }) {
    if (!project) return null;
    const fallbackImage = 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&q=80';
    const [activeImage, setActiveImage] = useState(project.image_url || fallbackImage);
    const gallery = (project.gallery && project.gallery.length > 0) ? project.gallery : [project.image_url || fallbackImage];

    return (
        <div className="fixed inset-0 z-[200] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white rounded-3xl overflow-hidden max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
                <div className="relative h-96 group">
                    <img src={activeImage} alt={project.name} className="w-full h-full object-cover transition-opacity duration-300" />
                    <button onClick={onClose} className="absolute top-4 right-4 w-9 h-9 bg-black/60 hover:bg-black text-white rounded-full flex items-center justify-center text-lg transition-colors z-10">
                        ×
                    </button>
                    <div className="absolute bottom-4 left-4 flex gap-2">
                        <span className="bg-[#2E63E8] text-white text-xs font-bold px-3 py-1 rounded-full">{project.completion_year}</span>
                        <span className="bg-black/60 text-white text-xs px-3 py-1 rounded-full backdrop-blur-sm">{project.project_type}</span>
                    </div>
                    
                    {/* Gallery Thumbnails */}
                    {gallery.length > 1 && (
                        <div className="absolute bottom-4 right-4 flex gap-2 overflow-x-auto max-w-[50%] p-1 bg-black/20 backdrop-blur rounded-xl">
                            {gallery.map((img, idx) => (
                                <img 
                                    key={idx} 
                                    src={img} 
                                    onClick={() => setActiveImage(img)}
                                    className={`w-12 h-12 object-cover rounded-lg cursor-pointer border-2 transition-all ${activeImage === img ? 'border-[#2E63E8] scale-110' : 'border-transparent opacity-70 hover:opacity-100'}`}
                                />
                            ))}
                        </div>
                    )}
                </div>
                <div className="p-7">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">{project.name}</h2>
                    <div className="flex items-center gap-1.5 text-[#2E63E8] text-sm font-semibold mb-4">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        </svg>
                        {project.location}
                    </div>
                    <p className="text-gray-600 leading-relaxed mb-6">{project.description}</p>
                    <div className="flex gap-4">
                        <a href="/contact" className="btn-yellow flex-1 text-center py-3 text-sm">
                            Book Free Consultation →
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function ProjectsPage() {
    const [projects, setProjects] = useState(STATIC_PROJECTS);
    const [cityFilter, setCityFilter] = useState('All');
    const [selectedProject, setSelectedProject] = useState(null);

    usePageMeta(
        'Interior Design Projects | Homes by Bliv Design Studio',
        'Browse Bliv Design Studio projects including independent houses, flats, bungalows and duplex flats across South India.'
    );

    useEffect(() => {
        fetch(`${API_BASE}/projects.php`)
            .then(r => r.json())
            .then(data => { 
                if (data.status === 'success' && Array.isArray(data.projects)) {
                    setProjects(data.projects);
                }
            })
            .catch(() => {/* fallback to static is already default state */ });
    }, []);

    const filtered = cityFilter === 'All' ? projects : projects.filter(p => p.city === cityFilter);
    const cities = ['All', ...new Set(projects.map(p => p.city).filter(Boolean))];


    return (
        <>
            <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />

            {/* Hero */}
            <section className="relative pt-36 pb-24 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-[#0A1128] via-[#1C2541] to-[#0D0D0D]" />
                <div className="relative max-w-7xl mx-auto px-4 text-center">
                    <span className="inline-block bg-[#2E63E8]/20 border border-[#2E63E8]/40 text-[#2E63E8] text-xs font-semibold px-5 py-2 rounded-full mb-5 uppercase tracking-widest">
                        Portfolio
                    </span>
                    <h1 className="text-5xl md:text-7xl font-bold text-white mb-5">Our Projects</h1>
                    <p className="text-gray-300 text-lg max-w-2xl mx-auto">
                        500+ luxury interior projects delivered across South India. Every space tells a unique design story.
                    </p>
                    <div className="flex justify-center gap-6 mt-10">
                        {[['500+', 'Projects'], ['1000+', 'Happy Clients'], ['5+', 'Cities']].map(([n, l]) => (
                            <div key={l} className="text-center">
                                <div className="text-3xl font-bold text-white">{n}</div>
                                <div className="text-gray-400 text-xs mt-1">{l}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Filter Bar */}
            <section className="bg-white border-b sticky top-[105px] z-40 shadow-sm">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex overflow-x-auto gap-2 py-3">
                        {cities.map(city => (
                            <button
                                key={city}
                                onClick={() => setCityFilter(city)}
                                className={`flex-shrink-0 px-5 py-2 rounded-full text-sm font-semibold transition-all
                  ${cityFilter === city ? 'bg-[#2E63E8] text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'}`}
                            >
                                {city}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Projects Grid */}
            <section className="section-pad bg-[#F8F9FA]">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filtered.map(project => (
                            <ProjectCard key={project.id} project={project} onClick={setSelectedProject} />
                        ))}
                    </div>

                    {filtered.length === 0 && (
                        <div className="text-center py-16">
                            <p className="text-gray-400 text-lg">No projects found for this filter.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* CTA */}
            <section className="bg-[#f0f4fe] py-16 px-4">
                <div className="max-w-2xl mx-auto text-center">
                    <h3 className="text-3xl font-bold text-gray-900 mb-4">Want to Start Your Own Project?</h3>
                    <p className="text-gray-600 mb-8">Book a free design consultation and let's create something extraordinary together.</p>
                    <a href="/contact" className="btn-yellow inline-block px-10 py-4">Book Free Consultation</a>
                </div>
            </section>
        </>
    );
}
